// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import less from 'less'

import "./assets/common.less";

import axios from 'axios'
import VueAxios from 'vue-axios'
import 'element-ui/lib/theme-chalk/display.css';
// Vue.prototype.$staticUrl = process.env.PROD_FILE_URL; //静态资源引入

// static资源路径配置
Vue.prototype.$staticUrl = process.env.NODE_ENV === 'development' ? '' : '';
console.log(process.env)

Vue.use(VueAxios, axios)
Vue.prototype.$axios = axios;

Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(less)


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js